var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.723,
    height: 22.467,
    viewBox: "0 0 7.07 5.944",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.941 -162.581)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline",
    transform: "matrix(.35278 0 0 -.35278 -293.921 377.348)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.592 607.887)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.908 3.908 0 01-3.903-3.904A3.908 3.908 0 010-7.808a3.909 3.909 0 013.904 3.904A3.908 3.908 0 010 0m0-8.708a4.81 4.81 0 00-4.804 4.804A4.81 4.81 0 000 .9a4.81 4.81 0 004.805-4.804A4.81 4.81 0 000-8.708"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.592 597.885)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a13.938 13.938 0 01-8.681-2.995 1.15 1.15 0 01.71-2.053H7.972a1.15 1.15 0 01.709 2.053A13.934 13.934 0 010 0m7.972-5.949H-7.971c-1.13 0-2.05.919-2.05 2.049 0 .634.287 1.223.785 1.613A14.825 14.825 0 000 .9C3.385.9 6.579-.202 9.236-2.287a2.051 2.051 0 00-1.264-3.662"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.5d3369127cbf9d456bc46837a68f48b3.svg";